import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SET_1D_ADVANCE_DRAW_SELECT_TIME, SET_1D_GAME_TIMER, Select1dGameTime } from '../../../redux/1d-slice/gameInfo1dSlice'
import moment from 'moment'
import { RESET_SLICE_STATE } from '../../../redux/2d-slice/seriesSlice2d'

function TimerControl() {
  const dispatch = useDispatch()
  const gameTimer2d = useSelector(Select1dGameTime)

  const [secondDiffShow, setSecondDiffShow] = useState(null)

  let getTime = (endTime) => {
    
    let startTime = moment()
    var secondsDiff = endTime.diff(startTime, 'seconds');
    if(secondsDiff===0){
      dispatch(SET_1D_GAME_TIMER(0))
      dispatch(RESET_SLICE_STATE());
      dispatch(SET_1D_ADVANCE_DRAW_SELECT_TIME([]))
    }
    setSecondDiffShow(secondsDiff)
  }

  useEffect(() => {
    if(!gameTimer2d || gameTimer2d === null){
      return
    }
    let endTime = moment()
    endTime.add(gameTimer2d, 'seconds')
      .format('LTS');
    let interval = setInterval(() => {
      getTime(endTime)
    }, 1000);

    return () => clearInterval(interval);
  }, [gameTimer2d]);
    
  return (
    <>{secondDiffShow ? moment.utc(secondDiffShow * 1000).format('mm:ss'):'00:00'}</>
  )
}

export default TimerControl